import { ArrowForwardIos } from "@mui/icons-material";
import { Typography } from "antd";
import { useDropzone } from "react-dropzone";
import "../../CSS/ComponentCSS/FileComponent.css"; // Import the CSS file for styling
import ButtonComponent from "./ButtonComponent";

const { Title } = Typography;

type FileComponentProps = {
  value: any;
  upload: (value: any, index?: any) => void;
  index?: any;
  accept?: any;
  onDelete?: (index: any, index2?: any) => void;
  language?: any;
  maxFiles?: any;
};

const FileComponent = (props: FileComponentProps) => {
  const handleDrop = (acceptedFiles: any) => {
    props.upload(acceptedFiles, props.index);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: props.accept,
    onDrop: handleDrop,
    multiple: true,
    maxFiles: props.maxFiles ? props.maxFiles : 15,
  });

  return (
    <div className="upload-container">
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? "active" : ""}`}
      >
        <input {...getInputProps()} />
        {props.language == 1
          ? "파일을 드래그해주세요."
          : props.language == 2
          ? "Please drag the file."
          : props.language == 3
          ? "ファイルをドラッグしてください。"
          : props.language == 4
          ? "请拖动文件。"
          : props.language == 5
          ? "請拖動文件。"
          : "파일을 드래그해주세요."}
        {props.maxFiles
          ? props.language == 1
            ? "(최대 2개)"
            : props.language == 2
            ? "(Up to 2)"
            : props.language == 3
            ? "(最大 2つ)"
            : props.language == 4
            ? "(最多2个)"
            : props.language == 5
            ? "(最多2個)"
            : "(최대 2개)"
          : ""}
      </div>
      <div className="file-list">
        <Title level={5} className="DetailName">
          {props.language == 1
            ? "업로드 파일 리스트"
            : props.language == 2
            ? "Upload File List"
            : props.language == 3
            ? "アップロードファイルリスト"
            : props.language == 4
            ? "上传文件列表"
            : props.language == 5
            ? "上傳文件列表"
            : "업로드 파일 리스트"}
        </Title>
        {props.value && props.value.length > 0 ? (
          <div>
            {props.value.map((file: any, index: any) => (
              <Title key={index} level={5} className="DetailName">
                <div>
                  <ArrowForwardIos fontSize="small" className="AnswerIcon" />
                  {file.name}
                </div>
                <ButtonComponent
                  fullWidth
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.onDelete) {
                      props.onDelete(index, props.index);
                    }
                  }}
                  style={{
                    backgroundColor: "rgb(148, 148, 148)",
                  }}
                >
                  삭제
                </ButtonComponent>
              </Title>
            ))}
          </div>
        ) : (
          <Title level={5} className="DetailName">
            <div>
              <ArrowForwardIos fontSize="small" className="AnswerIcon" /> X
            </div>
          </Title>
        )}
      </div>
    </div>
  );
};

export default FileComponent;
